import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { FileResponse, GstarClient } from 'src/app/web-api-client';

@Injectable()
export class ExportTaxRatesValuesService {
  private readonly gstarClient = inject(GstarClient);

  exportTaxRatesValuesToExcel(): Observable<FileResponse> {
    const investmentJurisdictionsIds: number[] = [];
    return this.gstarClient.exportrates(investmentJurisdictionsIds);
  }
}
